import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { PaymentService } from "../../shared/services/payment.service";
import { Subject, takeUntil } from "rxjs";
import { CollectionDetailsComponent } from "../collection-details/collection-details.component";
import { CollectionDetails } from "../collection-model";
import { ResponseCodes } from "../../shared/models/bankPaymentRes";
import { addHyphen } from "src/app/core/constants/constants";
import { ToastrService } from "ngx-toastr";
import { FormField, form } from "@angular/forms/signals";
import { Collection, collectionSchema, initialData } from "./collection.model";

@Component({
  selector: "app-collection",
  imports: [FormsModule],
  templateUrl: "./collection.component.html",
  styleUrls: ["./collection.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionComponent {
  router = inject(Router);
  paymentService = inject(PaymentService);

  referenceKey = "";
  submitted = false;
  destroy$ = new Subject();

  showDetails: boolean = false;
  details: CollectionDetails;

  toastService = inject(ToastrService);

  referenceKeyModel = signal<Collection>(initialData);
  referenceKeyForm = form(this.referenceKeyModel, collectionSchema);

  submit() {
    this.submitted = true;

    const refKey = this.referenceKey?.trim();

    if (!refKey) {
      return;
    }

    this.paymentService
      .validateCollection(refKey)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.responseCode === ResponseCodes.error) {
            this.toastService.error(res.responseDescription);
          }

          if (res.responseCode !== ResponseCodes.error) {
            this.router.navigate(["/payment/collection/details"], {
              queryParams: {
                referenceKey: this.referenceKey,
              },
            });
          }
        },
      });
  }
}
